import { TYPE_LABEL_MAP } from "../../constants/filter.constants";
import { ContentType } from "../../lib/__generated__/graphql";

const contentIconMap = {
  [ContentType.Demo]: "bxs-flask",
  [ContentType.Blog]: "bxs-quote-alt-left",
  [ContentType.Challenge]: "bxs-trophy",
  [ContentType.Profile]: "bxs-user-circle",
  [ContentType.Doc]: "bx-file-blank",
  [ContentType.CodebookTopic]: "bx-book-open",
  [ContentType.Compilation]: "bx-code-block",
  [ContentType.DatasetFamily]: "bxs-data",
  [ContentType.Webpage]: "bxs-window-alt",
};

export const ContentLabel = ({ type }: { type: ContentType }) => {
  return (
    <div
      data-component="ContentLabel"
      data-testid="content-label"
      className="plh-flex plh-items-center plh-gap-2 plh-text-grey-9"
    >
      <i
        className={`bx ${contentIconMap[type]} plh-text-[12px]`}
        data-testid={`content-icon-${type}`}
      />
      <span className="plh-font-roboto plh-text-caption">
        {TYPE_LABEL_MAP[type] /* removes the "s" from the end */}
      </span>
    </div>
  );
};
